const nextive_logo = "/images/nextive_solution_blue.png";
const encoder_logo = "/images/encoderit.webp";
const softic_logo = "/images/softic.png";
const edutech = "/images/projects/edutech.jpg";
const m7production = "/images/projects/m7Productions-min.jpg";
const krishokVhai = "/images/projects/krishok-vhai-min.jpg";
const medocare = "/images/projects/medocare-min.jpg";

export const socialMedia = [
    // {name: 'GitHub', url: 'https://github.com/nahidnfr123',},
    {name: 'Linkedin', url: 'https://www.linkedin.com/in/nahid-ferdous-892153215',},
    {name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100065708588326',},
    {name: 'Youtube', url: 'https://www.youtube.com/@codeknight3183',},
    // {name: 'Skype', url: '',},
]

export const skills = {
    development: [
        {name: 'Laravel', color: 'red', special: true},
        {name: 'Php', color: 'red', special: false},
        {name: 'MySql', color: 'red', special: false},
        {name: 'Nest Js', color: 'red', special: true},
        {name: 'MongoDB', color: 'red', special: true},
        {name: 'Nuxt Js', color: 'red', special: true},
        {name: 'Vue Js', color: 'red', special: true},
        // {name: 'Next Js', color: 'red', special: true},
        // {name: 'React Js', color: 'red', special: true},
        {name: 'Vuetify', color: 'red', special: true},
        {name: 'Ionic', color: 'red', special: false},
        // {name: 'Firebase', color: 'red', special: false},
        {name: 'Tailwind Css', color: 'red', special: false},
        {name: 'Javascript', color: 'red', special: false},
        {name: 'JQuery', color: 'red', special: false},
        {name: 'Bootstrap', color: 'red', special: false},
        {name: 'Scss', color: 'red', special: false},
        // {name: 'Css', color: 'red', special: false},
        // {name: 'Html', color: 'red', special: false},
    ],
    design: [
        {name: 'Figma', icon: 'SiFigma', special: false},
        {name: 'Adobe XD', icon: 'SiAdobexd', special: false},
        {name: 'Illustrator', icon: 'SiAdobeillustrator', special: false},
        {name: 'Photoshop', icon: 'SiAdobephotoshop', special: false},
    ],
    others: [
        {name: 'Agile Development'},
        {name: 'Git, Github, GitLab'},
        {name: 'Netlify, Varcel, CPanel, VPS: [ apache, nginx, pm2 ]'},
        {name: 'Jira, Slack, Trello, Click Up'},
        {name: 'Php Storm, Web Storm, Vs Code'},
        {name: 'UI/UX Design'},
        {name: 'Linux (Ubuntu, Manjaro)'},
    ]
}

export const calculateXP = (startDate, endDate = null) => {
    // Ensure both start and end are Date objects
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // Default to current date if endDate is null

    // Calculate the difference in milliseconds
    const diff = end.getTime() - start.getTime(); // .getTime() returns the number of milliseconds since the Unix epoch

    if (diff < 0) return 0;

    // Calculate years and months
    const years = Math.floor(diff / 31536000000); // 31536000000 ms in a year
    const months = Math.floor((diff % 31536000000) / 2628000000); // 2628000000 ms in a month

    // Return the result based on the years and months calculated
    if (years) {
        return `${years} year${years > 1 ? 's' : ''} ${months + 1} month${months + 1 > 1 ? 's' : ''}`;
    } else if (months) {
        return `${months + 1} month${months + 1 > 1 ? 's' : ''}`;
    } else {
        return null; // Return null if less than a month
    }
}

export const experience = [
    {
        name: 'Encoder IT',
        logo: encoder_logo,
        link: 'https://encoderit.net/',
        type: 'Software Company',
        startDate: 'March 2024',
        endDate: 'Present',
        xp: calculateXP('March 2024', new Date()),
        role: 'Full-Stack Web Developer',
        description: 'I am working at Encoder IT, as a Full-Stack Web Developer. ' +
            'I am engaged in maintaining and developing new features for existing projects working directly with clients.',
        coreTechnologies: ['Laravel', 'jQuery', 'MySQL', 'APIs']
    },
    {
        name: 'Softic',
        logo: softic_logo,
        link: 'https://softic.ai/',
        type: 'Software Company',
        startDate: 'April 2023',
        endDate: 'September 2023',
        // xp: calculateXP('April 2023', new Date()),
        xp: calculateXP('April 2023', 'September 2023'),
        role: 'Backend Web Developer',
        description: 'I worked at Softic, as a Backend Web Developer. ' +
            'I mainly build admin panels and apis for the frontend web and mobile apps. ' +
            'The main technologies I work with are:',
        coreTechnologies: ['Laravel', 'WebSocket', 'Pusher', 'MySQL', 'React.js', 'APIs']
    },
    {
        name: 'Nextive Solution',
        logo: nextive_logo,
        link: 'https://nextivesolution.com/',
        type: 'Edu-tech',
        startDate: 'July 2021',
        endDate: 'February 2023',
        xp: calculateXP('July 2021', 'February 2023'),
        role: 'Full-Stack Web Developer',
        description: 'I worked at Nextive Solution, as a Full-Stack Web Developer. ' +
            'It is an ed-tech company. ' +
            'Besides the web for some time i also had to work on a Hybrid mobile application using Ionic framework and Vue.js.\n ' +
            'The main technologies I worked with are: ',
        coreTechnologies: ['Laravel', 'MySQL', 'Nuxt.js', 'Vue.js', 'APIs', 'Ionic Framework', 'Vuetify', 'Scss']
    },
]

export const works = [
    {
        id: 1,
        name: 'LMS',
        photo: edutech,
        description: 'I\'ve worked on a lot of LMS web and mobile applications while I worked at Nextive Solution. ' +
            'Some important Features of the applications are ' +
            'Purchasing Course and Books, Online and manual Payment system,' +
            ' Online exam, Bulk and individual SMS, and many more. ' +
            'Some of the projects i have worked on are:',
        links: [
            {name: 'Admission Assistant', url: 'https://admissionassistant.com.bd/'},
            {name: 'March Forward', url: 'https://marchforwardbd.com/'},
            {name: 'Coursecab', url: 'https://www.coursecab.com/'},
            {name: 'Medilogy', url: 'https://medilogy.com.bd/'},
            {name: 'Lingual Academy', url: 'https://lingualacademy.com.bd/'},
            {name: 'Mediaim', url: 'https://mediaimbd.com/'},
        ],
        repository: '',
        for: 'Nextive Solution',
        date: 'Jul 2021 - Feb 2023',
        technologies: ['Laravel 8/9', 'Nuxt.Js', 'Vue.Js', 'Vuetify', 'Ionic Framework'],
    },
    {
        id: 2,
        name: 'M7 Productions',
        photo: m7production,
        description: 'M7 Productions is a software company where they develop video game assets & also have their own video games including Agontuk, Outlive & Zero Hour.',
        link: 'https://m7productions.gg/',
        repository: '',
        for: 'Client',
        date: 'Aug 2021',
        technologies: ['Nuxt.Js', 'Laravel 8', 'Scss', 'Bootstrap'],
    },
    {
        id: 3,
        name: 'Krishok Vhai',
        photo: krishokVhai,
        description: 'An e-commerce platform for rural farmers selling their goods and acquire agricultural inputs. ' +
            'Additionally, they will be able to pick up new farming techniques and receive regular weather information.',
        // link: 'https://krishok-vhai.nahidferdous.com/',
        repository: 'https://github.com/nahidnfr123/003-KrishokVhai',
        for: 'Final year project',
        date: 'May 2021',
        technologies: ['Vue.Js', 'Laravel 7', 'JQuery', 'Axios', 'Bootstrap'],
    },
    {
        id: 4,
        name: 'Medocare',
        photo: medocare,
        description: 'An Online medical service where patients can search for doctors and book appointment to get consultation online at their finger tips. ' +
            'Patients will also receive their prescription form doctors and get other medical advices through the blogs.',
        // link: 'https://medocare.nahidferdous.com/',
        repository: 'https://github.com/nahidnfr123/001-MedoCare',
        for: '3rd year project',
        date: 'Sept 2019',
        technologies: ['Laravel 6', 'JQuery', 'Ajax', 'Bootstrap'],
    },
]

const StarterProjects = [
    {
        active: true,
        progress: false,
        name: 'Nuxt 3, Pinia, Laravel Api | Starter Project',
        technologies: ['Nuxt Js', 'Pinia', 'Laravel'],
        features: [
            'Login',
            'Register',
            'Email Verification',
            'Password Reset',
            'Route Middlewares',
            'Profile Update',
            'Sanctum, Passport, JWT',
            'Frontend and server-side validation',
            'Tailwind CSS'
        ],
        subtitle: '',
        css: 'rotate-[10deg] group-hover:rotate-[20deg] group-hover:scale-75 group-hover:translate-x-14'
    },
    {
        active: true,
        progress: false,
        name: 'React, Redux, Laravel Api | Starter Project',
        technologies: ['React Js', 'Redux', 'Laravel'],
        features: [
            'Login',
            'Register',
            'Email Verification',
            'Password Reset',
            'Route Middlewares',
            'Profile Update',
            'Sanctum, Passport, JWT',
            'Frontend and Server-Side validation',
            'Material Ui'
        ],
        subtitle: '',
        css: 'group-hover:scale-75 group-hover:-translate-y-12'
    },
    {
        active: true,
        progress: false,
        name: 'Vue 3, Pinia, Laravel Api | Starter Project',
        technologies: ['Vue Js', 'Pinia', 'Laravel'],
        features: [
            'Login',
            'Register',
            'Email Verification',
            'Password Reset',
            'Route Middlewares',
            'Profile Update',
            'Sanctum, Passport, JWT',
            'Frontend and server-side validation',
            'Tailwind CSS'
        ],
        subtitle: '',
        css: 'rotate-[-10deg] group-hover:rotate-[-20deg] group-hover:scale-75 group-hover:-translate-x-14 group-hover:-translate-y-2'
    },
    // {
    //   active: true,
    //   progress: true,
    //   name: 'Next, Redux, Laravel Api | Starter Project',
    //   technologies: ['Next Js', 'Redux', 'Laravel'],
    //   features: [
    //     'Login',
    //     'Register',
    //     'Email Verification',
    //     'Password Reset',
    //     'Route Middlewares',
    //     'Profile Update',
    //     'Sanctum, Passport, JWT',
    //     'Frontend and Server-Side validation',
    //     'Chakra Ui'
    //   ],
    //   subtitle: 'Fill free to use it in your next dream project. It surely will save a day of your work.',
    //   link: 'https://github.com/nahidnfr123/StarterPack',
    // css: ''
    // },
]

export const otherProjects = [
    {
        active: true,
        progress: false,
        name: 'Portfolio V2 Nuxt | 2025',
        image: '/images/projects/portfoliov2.webp',
        technologies: ['Nuxt Js', 'GSAP', 'Tailwind',],
        subtitle: '',
        link: 'https://portfolio-v2-nuxt.vercel.app',
    },
    {
        active: true,
        progress: false,
        name: 'Nuxt, Vuetify Admin Template | 2024',
        image: '/images/projects/trinmora-admin-vuetify.png',
        technologies: ['Nuxt Js', 'Vuetify'],
        subtitle: '',
        link: 'https://trinmora-admin-vuetify.vercel.app',
    },
    {
        name: 'Starter Projects | 2023',
        subtitle: 'Fill free to use it in your next dream project. It surely will save a day of your work. ',
        description: 'These are starter web apps build with different javascript frameworks with basic project setup, authentication and middlewares. ' +
            'This are intended to reduce the time taken to start a project. ' +
            'Fill free to use it in your next dream project. It surely will save a day of your work. ',
        projects: StarterProjects,
        gitHub: 'https://github.com/nahidnfr123/StarterPack'
    },
    // {
    //     name: 'Starter Projects | 2023',
    //     subtitle: 'Fill free to use it in your next dream project. It surely will save a day of your work. ',
    //     description: 'These are starter web apps build with different javascript frameworks with basic project setup, authentication and middlewares. ' +
    //         'This are intended to reduce the time taken to start a project. ' +
    //         'Fill free to use it in your next dream project. It surely will save a day of your work. ',
    //     projects: StarterProjects,
    //     gitHub: 'https://github.com/nahidnfr123/StarterPack'
    // },
    {
        active: true,
        progress: false,
        name: 'Cube Design | 2023',
        image: '/images/projects/cube-design.png',
        technologies: ['Nuxt Js', 'Tailwind Css'],
        subtitle: '',
        link: 'https://cube-design-nuxt.vercel.app',
    },
]

export const services = []
